module.exports = __webpack_public_path__ + "static/media/uploadDocument.0e54e1c9.svg";